import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/shipContent', request)
}

async function post(request) {
    return await postMethod('/api/shipContent', request)
}

async function put(id, request) {
    return await putMethod(`/api/shipContent/${id}`, request)
}

export {get, post, put}
